<template>
    <div>
        <component :is="currentComponent"/>
    </div>
</template>

<script>

    import Pc from '@/components/pc'
    import Mobile from '@/components/mobile'
    import firebase from 'firebase/app'
    import 'firebase/analytics'

    const {getTimeStamp} = require('@/common')

    export default {
        name: "mainComponent",
        data() {
            return {
                currentComponent: null
            }
        },
        components: {
            // eslint-disable-next-line vue/no-unused-components
            Pc,
            // eslint-disable-next-line vue/no-unused-components
            Mobile
        },
        methods: {
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            },
            checkEnviroment() {
                if (this.isMobile()) {
                    this.currentComponent = Mobile
                } else {
                    this.currentComponent = Pc
                }
            }
        },
        created() {
            this.checkEnviroment()

            firebase.analytics().logEvent('enterVoucherContact', {
                referrerUrl: document.referrer,
                ts : getTimeStamp()
            });
        },
        beforeUpdate() {
            this.checkEnviroment()
        }
    }
</script>

<style scoped>

</style>